// extracted by mini-css-extract-plugin
module.exports = {"addressCard":"address-card_addressCard__fK7jb","stamp":"address-card_stamp__vNOHi"};